export enum REWARDS_SDK_METHODS {
    OPEN_REWARDS_POPUP = "openRewardsPopup",
    CLOSE_REWARDS_POPUP = "closeRewardsPopup",
    GET_REWARDS_PROGRAM_ACCOUNT = "getRewardsProgramAccount",
    GET_REWARDS_EARNING_RULES = "getRewardsEarningRules",
    GET_REWARDS_SPENDING_RULES = "getRewardsSpendingRules",
    GET_CUSTOMER_ACTIVE_REWARDS = "getCustomerActiveRewards",
    REDEEM_REWARD = "redeemReward",
    OPEN_REWARDS_MODAL = "openRewardsModal",
    GET_REWARDS_VIP_TIERS = "getRewardsVipTiers",
    GET_REWARDS_VIP_TIER_PROGRESS = "getRewardsVipTierProgress",
    SEND_VERIFICATION_TOKEN = "sendVerificationToken",
}

export const REWARDS_SDK_EVENTS = {
    popUpWidgetViewChanged: "popUpWidgetViewChanged",
} as const;
